import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from '../Page';

function ReportsAudienceEngagementPage(): JSX.Element {
  const { t } = useTranslation();

  return <Page title={t('Audience Engagement')}>{null}</Page>;
}

export default ReportsAudienceEngagementPage;
